var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1577 88.9341C59.1971 88.1282 65.8045 80.1111 64.91 71.0771C64.6423 68.2214 63.6476 65.6008 62.1487 63.3665L46.5525 0.409346L33.5219 65.9737C32.477 68.4392 32.0043 71.1641 32.2721 74.0197C33.1069 83.0457 41.1183 89.7399 50.1577 88.9341ZM47.6175 62.3669C53.2564 61.858 58.2363 65.9889 58.7794 71.6406C59.3226 77.2923 55.2295 82.2549 49.5906 82.7638C43.9516 83.2727 38.9718 79.1417 38.4286 73.4901C37.8518 67.8641 41.9785 62.8758 47.6175 62.3669Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayVector);
export default __webpack_public_path__ + "static/media/gray-vector.358d4a4102a9caddb2d43da07493c5e6.svg";
export { ForwardRef as ReactComponent };